export const brandConfigObjectMap = new Map();

export const Brands = {
    How2AiThailandAis: 'ais-th'
};

export const SourceGroups = Object.freeze({
    Penrose: 'penrose',
});

brandConfigObjectMap.set(Brands.How2AiThailandAis, {
    debug: `${process.env.VUE_APP_DEBUG_OPTION}` || false,
    assetBrand: 'ais-th',
    sourceGroup: SourceGroups.Penrose,
    serviceFamily: 'how2ai',
    tabTitle: 'HOW2AI',
    countryCode: 'TH',
    operator: 'AIS',
    productName: 'How2AI',
    subscribePrice: '10.70',
    currencyCode: 'THB',
    gtmIdentifier: undefined,
    /* The How2AI portal. Taken from `Ais:Games:HOW2AI_AIS_TH:GameUrl` in
       service.ais-integration-th, which is also the {url} the service puts in its welcome
       SMS, so it is the same destination the subscriber is sent to by AIS. */
    portalUrl: 'https://th-ais.how2ai.co/',
    /* No terms copy exists for How2AI. While this is undefined the footer shows no terms
       link at all; set it to a hosted policy and the link appears. */
    termsAndConditionsUrl: undefined
});
